import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const updateStatus = () => setOffline(typeof navigator !== "undefined" && !navigator.onLine);
    updateStatus();
    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);
    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-orange-500 text-white text-sm font-semibold px-4 py-2 text-center flex items-center justify-center gap-2 shadow-md"
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
    >
      <WifiOff size={14} />
      <span>Mode hors-ligne - affichage du contenu mis en cache.</span>
    </div>
  );
}
